module.exports = __webpack_public_path__ + "img/poplingdang.9bd37124.png";